<template>
  <div class="p-0">

    <div class="col-12 p-0 m-0">
      <app-tab :tabs="tabs" type="horizontal" />
    </div>

  </div>
</template>

<script>


export default {

  data() {
    return {
      tabs: [
        {
          icon: "briefcase",
          name: "Acreditaciones Iniciales y Ampliaciones",
          component: "audit-acc-init-ext",
          permission: "",
        },
        {
          icon: "activity",
          name: "Vigilancias y Renovaciones",
          component: "audit-vigilance-renovation",
          permission: "",
        },
        {
          icon: "activity",
          name: "Cargas de datos Inicial",
          component: "audit-data-init",
          permission: "",
        }
      ]
    };
  },
  created() {


  },
  methods: {

  },
};
</script>
